<template>
	<div class="iCard">
		<search-i-dard
			v-on:onSubmit="onSubmit"
			v-on:resetSearch="resetSearch"
			:search="search"
		>
		</search-i-dard>
		<add-i-dard
			:iDard="iDard"
			:countrySet="countrySet"
			v-on:cancel="cancel"
			:dialogIDard="dialogIDard"
		>
		</add-i-dard>
		<div class="vue-padding radius">
			<el-table
				v-loading="loading"
				:empty-text="$t('common.noData')"
				:element-loading-text="$t('common.loading')"
				:data="cardList"
				style="width: 100%"
				max-height="638"
				:border="true"
			>
				<el-table-column
					prop="equipmentNo"
					:label="$t('machineRecord.equipmentNo')"
					width="200"
					:align="'center'"
				></el-table-column>
				<el-table-column
					prop="content"
					:label="$t('iDard.IdInfo')"
				></el-table-column>
				<el-table-column
					prop="pdfContent"
					:label="$t('iDard.pdfContent')"
				></el-table-column>
				<el-table-column
					prop="frontImg"
					:label="$t('iDard.frontImg')"
					width="150"
					:align="'center'"
				>
					<template slot-scope="scope">
						<el-image
							style="width: 60px;height: 60px"
							:src="scope.row.frontImg"
							fit="fill"
						></el-image>
					</template>
				</el-table-column>
				<el-table-column
					prop="backImg"
					:label="$t('iDard.backImg')"
					width="150"
					:align="'center'"
				>
					<template slot-scope="scope">
						<el-image
							style="width: 60px;height: 60px"
							:src="scope.row.backImg"
							fit="fill"
						></el-image>
					</template>
				</el-table-column>
				<el-table-column
					prop="createTime"
					:label="$t('iDard.createTime')"
					width="160"
					:align="'center'"
				></el-table-column>
				<el-table-column
					fixed="right"
					:label="$t('common.operate')"
					width="120"
					:align="'center'"
				>
					<template slot-scope="scope">
						<el-button
							size="mini"
							type="primary"
							v-hasPerm="['sys:idard']"
							@click="addIDard(scope.row)"
							>{{ $t("addIDard.add") }}</el-button
						>
						<!-- <el-button type="danger" v-hasPerm="['sys:card:delete']" size="mini" @click="delIDard(scope.row)">{{$t('common.delete')}}</el-button> -->
					</template>
				</el-table-column>
			</el-table>
			<el-pagination
				background
				layout="prev, pager, next"
				:current-page="page.pageIndex"
				:total="page.totalSize"
				:page-size="page.pageSize"
				@current-change="currentChange"
			></el-pagination>
		</div>
	</div>
</template>
<script>
import searchIDard from "_c/system/ic/SearchIDard";
import addIDard from "_c/system/ic/AddIDard";
export default {
	name: "IDard",
	components: {
		searchIDard,
		addIDard,
	},
	data() {
		return {
			page: {
				pageSize: 10,
				pageIndex: 1,
			},
			search: {
				startTime: "",
				endDate: "",
			},
			loading: false,
			dialogIDard: false,
			iDard: {
				id: "",
				name: "",
				type: "",
				pdfType: "",
				country: "",
				year: "",
				month: "",
				day: "",
				pdfYear: "",
				pdfMonth: "",
				pdfDay: "",
				content: "",
			},
			countrySet: [],
		};
	},
	mounted() {
		this.getCountry();
		this.currentChange();
	},
	methods: {
		getCountry() {
			this.$api.dict("sys_idcard_country").then(res => {
				if (res.code === 0) {
					this.countrySet = res.data;
				}
			});
		},
		currentChange(pageIndex) {
			this.loading = true;
			this.page.pageIndex = pageIndex ? pageIndex : 1;
			let obj = this.$cloud.objMerge(this.search, this.page);
			this.$api
				.request(this.$url.IDard.applyIDard, this.$method.get, obj)
				.then(res => {
					if (res.code === 0) {
						this.cardList = res.data.records;
						this.page.totalSize = parseInt(res.data.total);
					}
					this.loading = false;
				})
				.catch(() => {
					this.loading = false;
				});
		},
		addIDard(row) {
			this.dialogIDard = true;
			this.iDard.id = row.id;
			this.iDard.content = row.content;
		},
		cancel(dialog, state) {
			this.dialogIDard = dialog;
			if (state) {
				this.currentChange();
			}
		},
		onSubmit(data) {
			this.search = data;
			this.currentChange();
		},
		resetSearch(data) {
			this.search = data;
			this.currentChange();
		},
		delIDard(row) {
			return;
			this.$confirm(this.$t("iCard.delete"), this.$t("common.warning"), {
				confirmButtonText: this.$t("common.definite"),
				cancelButtonText: this.$t("common.cancel"),
				type: "warning",
			}).then(() => {
				this.$api
					.request(this.$url.ICard.delete, this.$method.delete, { id: row.id })
					.then(res => {
						if (res.code === 0) {
							this.$notify({
								title: this.$t("common.tip"),
								message: res.msg,
								type: "success",
							});
							this.currentChange();
						}
					});
			});
		},
	},
};
</script>

<style lang="scss"></style>
